import React from 'react'

export function getSiteIdByLocaleId(sites, localeID) {
    for (const site of sites) {
        for (const locale of site.l10n.supportedLocales) {
            if (locale?.alias.toLowerCase() === localeID.toLowerCase()) {
                return site.id
            }
        }
    }
    return null // Return null if no matching site ID is found
}

export function formatDate(dateString) {
    if (!dateString) {
        return
    }

    const [month, day, year] = dateString.split('/');

    const fullYear = year.length === 2 ? `20${year}` : year;

    const date = new Date(fullYear, month - 1, day);

    return date.toLocaleDateString('en-GB', {
        day: 'numeric',
        month: 'short',
        year: 'numeric'
    });
}

export const getCountryName = (countryCode) => {
    try {
        return new Intl.DisplayNames(['en'], { type: 'region' }).of(countryCode.toUpperCase());
    } catch (error) {
        console.warn('Error getting country name:', error);
        return countryCode;
    }
}


/**
* Generates an array of React <meta> tag elements based on the provided tag values.
* If a tag value contains the placeholder '${OriginalRequestURL}', it is replaced with the current page's full URL.
*
* @param {Array<Object>} tagValues - An array of objects where each object represents a meta tag with a single key-value pair.
* @returns {Array<JSX.Element>} An array of React <meta> elements with the appropriate name and content attributes.
*/
export const generateMetaTags = (tagValues, props) => {
    if (!tagValues) return
    return tagValues.map((tagObj, idx) => {
        const [key, value] = Object.entries(tagObj)[0]
        return <meta key={idx} name={key} content={value} />
    })
}

/**
* Generates an array of React <link> elements for alternate URLs based on provided hreflang and url properties.
* Filters the input array to include only objects with valid hreflang and url values, then maps each to a <link> element
* with appropriate attributes for use in SEO and internationalization.
*
* @param {Array<Object>} c_alternateURLs - Array of alternate URL objects, each containing 'hreflang' and 'url' properties.
* @returns {Array<React.ReactElement>} Array of React <link> elements for alternate URLs, or an empty array if input is invalid or empty.
*/
export const generateAlternateUrls = (c_alternateURLs) => {
    return Array.isArray(c_alternateURLs) && c_alternateURLs
        .filter((alt) => alt?.hreflang && alt?.url)
        .map((alt) => (
            <link
                rel="alternate"
                hreflang={alt.hreflang}
                href={alt.url}
                key={`${alt.hreflang}-${alt.url}`}
            />
        )
    )
}

/**
 * This util func determines if the app is finished hydration
 * @return {boolean}
 */
export const isHydrated = () => typeof window !== 'undefined' && !window.__HYDRATING__
